import routerOptions0 from "D:/a/1/s/frontend/web/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  strict: true,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}